import { get } from 'lodash';

import { EMPTY_ARR } from 'Services/constants/empty';

export const ModalsActionTypes = {
  MODAL_CLOSE: 'MODAL_CLOSE',
  MODAL_CLOSE_ALL: 'MODAL_CLOSE_ALL',
  MODAL_OPEN: 'MODAL_OPEN',
};

const modalClose = (modalId) => ({
  type: ModalsActionTypes.MODAL_CLOSE,
  payload: {
    modalId,
  },
});

const modalCloseAll = () => ({
  type: ModalsActionTypes.MODAL_CLOSE_ALL,
});

const modalOpen = (modal) => (dispatch, getState) => {
  const currentState = getState();
  const currentModals = get(currentState, ['Modals'], EMPTY_ARR);
  const hasModalWithSameId = currentModals.find((currentModal) => currentModal.id === modal.id);
  if (!hasModalWithSameId) {
    dispatch(({
      type: ModalsActionTypes.MODAL_OPEN,
      payload: {
        ...modal,
      },
    }));
  }
};

export const ModalsActions = {
  modalClose,
  modalCloseAll,
  modalOpen,
};
